exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3f7-WqBuz_Vc2CRQS0kSTk{min-width:44px;display:-webkit-box;display:-ms-flexbox;display:flex}", ""]);
// Exports
exports.locals = {
	"bigHoverActionContainer": "_3f7-WqBuz_Vc2CRQS0kSTk"
};